import { EArticleCategory, IArticleListData } from 'Pages/Blog/Hooks/Definitions/Article.d';
import { useFetchArticles } from 'Pages/Blog/Hooks/useFetchArticles';
import React, { useEffect, useMemo } from 'react';
import KickImage from 'Reuseables/KickImage';
import PopularItem from '../../Atoms/PopularItem';
import ReactPlaceholder from 'react-placeholder';
import 'react-placeholder/lib/reactPlaceholder.css';
import { TextBlock, RectShape } from 'react-placeholder/lib/placeholders';
import { useParams } from 'react-router';

import { IPopularProps } from './Popular.definitions';

/** CSS import */
import Styles from './Popular.module.scss';

const CustomPlaceholder: React.FC = () => {
  return (
    <div className={Styles['placeholder']}>
      {Array.from({ length: 5 }).map((_, index) => (
        <div
          key={`popular-placeholder-${index}`}
          className={Styles['placeholder-item']}
        >
          <RectShape color="#eeeeee" style={{ width: '100%', height: 98 }} />
          <TextBlock rows={3} color="#eeeeee" />
        </div>
      ))}
    </div>
  );
};

const Popular: React.FC<IPopularProps> = ({ }: IPopularProps) => {
  const params = useParams<{ slug: string }>();
  const slug = params.slug || '';

  const { data, isReady, manualReset } = useFetchArticles({
    category: EArticleCategory.Popular,
  });

  const trimedData = useMemo(() => {
    if (!data?.length) return [];

    return data.splice(0, 5)
  }, [data])
  
  useEffect(() => {
    return () => {
      manualReset()
    }
  }, [slug])

  return (
    <div className={Styles['wrapper']}>
      <div className={Styles['second-box']}>
        <p className={Styles['title']}>Popular</p>
        <ReactPlaceholder
          customPlaceholder={<CustomPlaceholder />}
          ready={isReady}
        >
          {trimedData.map((item) => (
            <PopularItem
              key={item.id}
              title={item.title}
              date={item.created_at}
              image={item.thumbnail?.URL}
              slug={item.slug}
            />
          ))}
        </ReactPlaceholder>
      </div>
    </div>
  );
};

export default Popular;
